import React from 'react';
import ReactDOM from 'react-dom';
import { createGlobalStyle } from 'styled-components';
import StuckToTheBottom from './components/StuckToTheBottom';
import BottomNavAction from './components/BottomNavAction';
import GetCareIcon from './icons/GetCareIcon';
import InsuranceIcon from './icons/InsuranceIcon';
import ProfileIcon from './icons/ProfileIcon';

const GlobalStyles = createGlobalStyle`
  #app {
    width: 100%;
    padding-bottom: 56px;
  }

  body, html {
    height: 100%;
    width: 100%;
  }
`;

type Props = {
  viewName?: string;
};

const BottomNav = (props: Props) => {
  const { viewName } = props;

  if (typeof document === 'undefined') return null;

  return ReactDOM.createPortal(
    <>
      <StuckToTheBottom viewName={viewName}>
        <BottomNavAction icon={<GetCareIcon />} label="Get Care" />
        <BottomNavAction icon={<InsuranceIcon />} label="Insurance" />
        <BottomNavAction icon={<ProfileIcon />} label="Profile" />
      </StuckToTheBottom>

      <GlobalStyles />
    </>,
    document.body
  );
};

export default BottomNav;
